import React from 'react';

const SchoolLogo = () => {
    return (<div><img src='/assets/images/Schools/SIL-logo.jpg' /></div>)
}

export default SchoolLogo;